const isCan = async (perms, userPerms) => {
    try {
        const allIncluded = perms.every(perm => userPerms.includes(perm));
        return allIncluded ? true : null
    } catch (error) {
        return null
    }
}

export default isCan;

